/* eslint-disable react/jsx-props-no-spreading */
import Skeleton from 'react-loading-skeleton';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import Button from '@mui/material/Button';
// import SvgIcon from '@mui/material/SvgIcon';
// import CaretRight from '@digital-hig/icon/lib/esm/icons/caret-right';
import window from 'global';
import EnvContext from './envContext';
import {
  ENVIRONMENT,
  AA_EVENT_CONTINUE, ROUTER_BASENAME,
} from './constants';
import {
  orderCourseIds, getNextIncompleteUrl, getEnvironmentConstant,
} from './utilities';
import {
  getLearningRecords,
  getUserDetails,
  hasFetchedLearningRecords,
  isAuthChecked,
} from '../store/userSlice';
import { triggerCourseStatusChange, triggerManualLinkClick, triggerModuleStatusChange } from './analyticsApi';
import { LoginClickHandler } from './login';

const StatusButton = ({
  hasStarted, hasCompleted, courseData, moduleData, size, variant, startIcon, btnLabel, analyticsCallback,
}) => {
  const { userid: uid } = useSelector(getUserDetails);
  const authChecked = useSelector(isAuthChecked);
  const recordChecked = useSelector(hasFetchedLearningRecords);
  const learningRecords = useSelector(getLearningRecords);
  const envContext = useContext(EnvContext);
  const env = envContext[ENVIRONMENT];
  const history = useHistory();
  let orderedIds = [];
  let moduleCtxUnitIds = [];

  const handleContinue = () => {
    let url = '/';
    if (analyticsCallback) {
      analyticsCallback();
    } else {
      triggerManualLinkClick({ linkTitle: btnLabel || 'Continue' });
    }
    if (courseData && courseData.uri && courseData.tutorials) {
      // Trigger Course Status Change Continue
      triggerCourseStatusChange({
        courseData, status: AA_EVENT_CONTINUE, learningRecords, env,
      });
      const { tutorials = [] } = courseData;
      orderedIds = tutorials.map((tutorial) => tutorial.id);
      url = getNextIncompleteUrl({
        type: 'module',
        courseUri: courseData.uri,
        orderedIds,
        learningRecords,
        env,
      });
    } else if (moduleData && moduleData.uri) {
      // Trigger Module Status Change - Continue
      triggerModuleStatusChange({
        moduleData, status: AA_EVENT_CONTINUE, learningRecords, env, moduleId: moduleData.id,
      });

      const moduleCtxUnits = moduleData.units || [];
      moduleCtxUnitIds = moduleCtxUnits.map((u) => u.id);
      orderedIds = orderCourseIds({ modules: [moduleData] });
      url = getNextIncompleteUrl({
        type: 'unit',
        courseUri: moduleData.uri,
        orderedIds,
        learningRecords,
        env,
      });
    }
    history.push(url);
  };

  const handleStart = ({ forceLogin }) => {
    let url = '/';
    if (analyticsCallback) {
      analyticsCallback();
    } else if (forceLogin) {
      triggerManualLinkClick({ linkTitle: btnLabel || 'Sign in and get started' });
    } else {
      triggerManualLinkClick({ linkTitle: btnLabel || 'Start' });
    }
    if (courseData && courseData.uri && btnLabel && btnLabel === 'See next steps') {
      url = courseData.uri;
    } else if (courseData && courseData.tutorials && courseData.uri) {
      const { tutorials = [] } = courseData;
      orderedIds = orderCourseIds({ modules: tutorials });
      url = `${courseData.uri}/module/${tutorials[0].id}`;
    } else if (moduleData) {
      const moduleCtxUnits = moduleData.units || [];
      moduleCtxUnitIds = moduleCtxUnits.map((u) => u.id);
      url = `${moduleData.uri}/unit/${moduleCtxUnitIds[0]}`;
    }
    if (forceLogin) {
      // Force user to Login page.  Redirect to first unit of course/module after login.
      LoginClickHandler(null, `${window?.location?.origin}${getEnvironmentConstant({ key: ROUTER_BASENAME, env })}${url}`);
    } else {
      history.push(url);
    }
  };

  if (authChecked && (!uid || recordChecked)) {
    if (hasStarted && hasCompleted) {
      return <></>;
    }
    if (hasStarted && !hasCompleted) {
      return (
        <Button
          variant={variant}
          size={size}
          className="statusButton"
          // endIcon={!startIcon ? <SvgIcon><CaretRight /></SvgIcon> : <></>}
          startIcon={startIcon}
          onClick={handleContinue}
        >
          {btnLabel || 'Continue' }
        </Button>
      );
    }
    if (!uid) {
      // User is authChecked but not logged in.  Show Sign in button.
      return (
        <Button
          variant={variant}
          size={size}
          className="statusButton"
          // endIcon={!startIcon ? <SvgIcon><CaretRight /></SvgIcon> : <></>}
          startIcon={startIcon}
          onClick={() => handleStart({ forceLogin: true })}
        >
          Sign in and get started
        </Button>
      );
    }
    return (
      <Button
        variant={variant}
        size={size}
        className="statusButton"
        // endIcon={!startIcon ? <SvgIcon><CaretRight /></SvgIcon> : <></>}
        startIcon={startIcon}
        onClick={handleStart}
      >
        {btnLabel || 'Get started' }
      </Button>
    );
  }

  return (
    <Skeleton width={130} height={40} />
  );
};

StatusButton.propTypes = {
  hasStarted: PropTypes.bool.isRequired,
  hasCompleted: PropTypes.bool.isRequired,
  analyticsCallback: PropTypes.func,
  courseData: PropTypes.shape({
    uri: PropTypes.string,
    modules: PropTypes.arrayOf(PropTypes.shape({})),
    unitLookup: PropTypes.shape({}),
    tutorials: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  moduleData: PropTypes.shape({
    id: PropTypes.string,
    uri: PropTypes.string,
    units: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  size: PropTypes.string,
  variant: PropTypes.string,
  startIcon: PropTypes.string,
  btnLabel: PropTypes.string,
};

StatusButton.defaultProps = {
  courseData: null,
  moduleData: null,
  size: 'medium',
  variant: 'contained',
  startIcon: '',
  btnLabel: undefined,
  analyticsCallback: undefined,
};

export default StatusButton;
